import React from 'react'
import "./OrdrReceipt.scss"
import { useSelector } from 'react-redux';
import { formatNumberWithCommas } from '../../../Helper/helper';
import { BID_REQUEST_STATE } from "../../../Config/config"
import moment from 'moment-timezone';
import { formatNumberOrStringAfterTwoDecimals, toSentenceCase } from '../../components.utils';

const OrdrReceipt = ({
   orderDetails
}) => {
   const { statusInfo } = orderDetails;
   if (!statusInfo && !Array.isArray(statusInfo) && statusInfo.length) return <></>;
   const profileData = useSelector((state) => state.userStore.profileData);

   const deliveredDate = statusInfo.find(item => item.bidRequestState === BID_REQUEST_STATE.delivered).statusDate;

   const formattedDeliveryDate = formatDateWithTimeZone(deliveredDate);
   const formattedAwardedDate = formatDateWithTimeZone(orderDetails.awardedDate)
   const tax = orderDetails?.sellerBidPriceDetail?.sellerBidPriceDetail?.tax;
   let fedTax = "0.000";
   let stateTax = "0.000";
   let surchargeTax = "0.000";
   if (tax?.bidTaxesAppliedRate) {
      if (orderDetails.productType === "Gasoline") {
         fedTax = (parseFloat(tax.bidTaxesAppliedRate.fedral?.gasEnvironment || 0) + parseFloat(tax.bidTaxesAppliedRate.fedral?.gasExercise || 0)).toFixed(3);
         stateTax = (parseFloat(tax.bidTaxesAppliedRate.state?.gasOilSpillHazardousSubstance || 0) + parseFloat(tax.bidTaxesAppliedRate.state?.gasExercise || 0) + parseFloat(tax.bidTaxesAppliedRate.state?.gasPetroleumProductTax || 0)).toFixed(3);
         surchargeTax = (parseFloat(tax.bidTaxesAppliedRate.surcharges?.gasSurcharge || 0) + parseFloat(tax.bidTaxesAppliedRate.surcharges?.gasEnvironmentSurcharge || 0)).toFixed(3);
      } else {
         fedTax = (parseFloat(tax.bidTaxesAppliedRate.fedral?.dieselEnvironment || 0) + parseFloat(tax.bidTaxesAppliedRate.fedral?.dieselExercise || 0)).toFixed(3);
         stateTax = (parseFloat(tax.bidTaxesAppliedRate.state?.dieselPetroleumProductTax || 0) + parseFloat(tax.bidTaxesAppliedRate.state?.dieselExercise || 0) + parseFloat(tax.bidTaxesAppliedRate.state?.dieselOilSpillHazardousSubstance || 0)).toFixed(3);
         surchargeTax = (parseFloat(tax.bidTaxesAppliedRate.surcharges?.dieselSurcharge || 0) + parseFloat(tax.bidTaxesAppliedRate.surcharges?.dieselEnvironmentSurcharge || 0)).toFixed(3);
      }
   }

   const haulDistanceFormatted = formatNumberOrStringAfterTwoDecimals(orderDetails?.sellerBidPriceDetail?.sellerBidPriceDetail?.totalDistanceInMile);
   const haulDistanceMilesWord = haulDistanceFormatted === "1.00" ? "mile" : "miles";

   return (
      <div className='ordr-receipt-container-we text-transform-none'>
         <div className='A4Paper' id="content">
            <div className="A4-paper-container order-invoice-grid">

               <div className="div1">
                  <svg width="424" height="158" viewBox="0 0 424 158" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M120.361 72.7068L113.045 114.948C108.779 138.715 88.6527 158.008 50.0369 158.008C11.5948 158.008 -3.42243 137.699 0.644995 114.948L7.9614 72.7068C12.2272 48.7421 31.9443 29.2383 71.2049 29.2383C108.977 29.2383 124.429 49.9564 120.361 72.7068ZM66.0958 62.9548C53.6952 62.9548 48.0032 69.0513 46.1679 79.0635L41.0961 108.307C39.2607 118.468 42.7205 124.415 55.1212 124.415C67.3111 124.415 73.003 118.53 74.8383 108.307L79.9102 79.0635C81.7455 69.0513 78.1245 62.9548 66.0958 62.9548Z" fill="#333333" />
                     <path d="M214.42 29.2383L208.332 62.9463H199.003C182.373 62.9463 176.285 67.6166 173.451 83.8573L160.905 156.142H121.73L133.906 85.889C141.615 42.4316 157.836 29.2383 208.542 29.2383H214.42Z" fill="#333333" />
                     <path d="M215.911 72.222C220.777 44.8356 234.584 29.416 266.854 29.416C280.054 29.416 288.164 32.8687 294.863 37.1258L301.364 0H340.531L320.434 114.805C315.357 143.405 298.318 158.007 258.396 158.007C220.443 158.007 204.605 137.316 209.075 111.551L215.911 72.222ZM262.804 124.545C274.977 124.545 280.66 118.468 282.481 108.457L287.768 77.828C289.588 67.9278 286.133 61.8144 273.961 61.8144C261.789 61.8144 256.093 67.8907 254.273 77.828L248.799 108.457C247.165 118.456 250.62 124.532 262.804 124.532V124.545Z" fill="#333333" />
                     <path d="M424 29.2383L417.911 62.9463H408.581C391.948 62.9463 385.872 67.6166 383.026 83.8573L370.453 156.142H331.311L343.475 85.889C351.197 42.4316 367.409 29.2383 418.122 29.2383H424Z" fill="#333333" />
                  </svg>
               </div>
               <div className="div2">
                  <span style={{ flex: 1 }}>Statement for order #</span>
                  <span>{orderDetails.orderId}</span>
               </div>
               <div className="div3 ordr-invoice-header-title">
                  Order details:
               </div>
               <div className="div4 ">
                  <div className="ordr-time-container">
                     <div className="ordr-time-container-div1">Order completed: </div>
                     <div className="ordr-time-container-div2">
                        <span>{formattedDeliveryDate.date}</span>
                        <span className='text-uppercase'>{formattedDeliveryDate.time}&nbsp;&nbsp;&nbsp;&nbsp;PDT</span>
                     </div>
                     <div className="ordr-time-container-div3">Order awarded:</div>
                     <div className="ordr-time-container-div4">
                        <span>{formattedAwardedDate.date}</span>
                        <span className='text-uppercase'>{formattedAwardedDate.time}&nbsp;&nbsp;&nbsp;&nbsp;PDT</span>
                     </div>
                  </div>
                  <div className="ordr-dets-container">
                     <div className="ordr-dets-container-div1">Ordered by:</div>
                     <div className="ordr-dets-container-div2">{profileData.companyName}</div>
                     <div className="ordr-dets-container-div3">Quantity ordered:</div>
                     <div className="ordr-dets-container-div4">{formatNumberWithCommas(+(orderDetails.orderSize).toFixed(2))}&nbsp;{formatNumberWithCommas(parseFloat(orderDetails?.sellerBidPriceDetail?.sellerBidPriceDetail?.quantity).toFixed(2)) === "1.00" ? "gallon" : "gallons"}</div>
                     <div className="ordr-dets-container-div5">Product type:</div>
                     <div className="ordr-dets-container-div6">{orderDetails?.productType[0]?.fuelType}</div>
                     <div className="ordr-dets-container-div7">Location:</div>
                     <div className="ordr-dets-container-div8">{`${orderDetails?.terminalDetails[0]?.terminalName}, ${toSentenceCase(orderDetails?.terminalDetails[0]?.supplierName)}`}</div>
                     <div className="ordr-dets-container-div-blank"></div>
                     <div className="ordr-dets-container-div9">
                        <span>{orderDetails?.locationDetails?.streetAddress}</span><br />
                        <span>{orderDetails?.locationDetails?.city}, {orderDetails?.locationDetails?.state}, {orderDetails?.locationDetails?.zip}</span>
                     </div>
                     <div className="ordr-dets-container-div10">Instructions:</div>
                     <div className="ordr-dets-container-div11">{`${toSentenceCase(orderDetails?.otherNotes)}`}</div>
                     <div className="ordr-dets-container-div12">Terminal:</div>
                     <div className="ordr-dets-container-div13">

                        <span>{`${orderDetails?.terminalDetails[0]?.terminalName}, ${toSentenceCase(orderDetails?.terminalDetails[0]?.supplierName)}`}</span><br />
                        <span>{orderDetails?.terminalDetails[0]?.terminalId}</span>

                     </div>
                     <div className="ordr-dets-container-div14">Haul distance:</div>
                     <div className="ordr-dets-container-div15">{haulDistanceFormatted} {haulDistanceMilesWord}</div>
                  </div>
               </div>
               <div className="div5 ordr-invoice-header-title">
                  Transaction details:
               </div>
               <div className="div6">
                  <div className="ordr-time-container-space">
                     <div className="ordr-transection-container-div1">Quantity delivered:</div>
                     <div className="ordr-transection-container-div2">
                        <>{formatNumberWithCommas(parseFloat(orderDetails?.sellerBidPriceDetail?.sellerBidPriceDetail?.quantity).toFixed(2))}</>
                     </div>
                     <div className="ordr-transection-container-div3">Bid price:</div>
                     <div className="ordr-transection-container-div4">$
                        {formatNumberWithCommas(parseFloat(orderDetails?.sellerBidPriceDetail?.sellerBidPriceDetail?.bidPricePerGallon).toFixed(2))}
                     </div>
                  </div>
                  <div className="ordr-invoice-right-space">
                     <div className="row">{formatNumberWithCommas(parseFloat(orderDetails?.sellerBidPriceDetail?.sellerBidPriceDetail?.quantity).toFixed(2)) === "1.00" ? "gallon" : "gallons"}</div>
                     <div className="row">/gallon</div>
                  </div>
               </div>
               <div className="div7">
                  <OrderTotalPrice sumTitle="Sub-total" price={formatNumberWithCommas(parseFloat(orderDetails?.sellerBidPriceDetail?.sellerBidPriceDetail?.wholePriceOfQuantity).toFixed(2))} />
                  <div className="ordr-invoice-right-space" />
               </div>
               <div className="div8">
                  <div className="ordr-dets-container space">
                     <div className="ordr-dets-container-div1 tax-title-container">
                        <span>Freight charge</span>
                        <span>{formatNumberOrStringAfterTwoDecimals(parseFloat(orderDetails?.sellerBidPriceDetail?.sellerBidPriceDetail?.totalDistanceInMile))} miles @ {formatNumberOrStringAfterTwoDecimals(parseFloat(orderDetails?.sellerBidPriceDetail?.sellerBidPriceDetail?.perMilePrice))}/mile:</span>
                     </div>
                     <div className="ordr-dets-container-div2 tax-price">${formatNumberWithCommas(parseFloat(orderDetails?.sellerBidPriceDetail?.sellerBidPriceDetail?.freightCharges).toFixed(2))}</div>
                     <div className="ordr-dets-container-div3 tax-title-container">
                        <span>Federal tax</span>
                        <span>{formatNumberWithCommas(parseFloat(fedTax).toFixed(3))}/gallon:</span>
                     </div>
                     <div className="ordr-dets-container-div4 tax-price">${formatNumberWithCommas(parseFloat(orderDetails?.sellerBidPriceDetail?.sellerBidPriceDetail?.tax?.bidTaxesPrice.fedral.total).toFixed(2))}</div>
                     <div className="ordr-dets-container-div5 tax-title-container">
                        <span>State tax</span>
                        <span>{formatNumberWithCommas(parseFloat(stateTax).toFixed(3))}/gallon:</span>
                     </div>
                     <div className="ordr-dets-container-div6 tax-price">{<div className="ordr-dets-container-div4 tax-price">${parseFloat(orderDetails?.sellerBidPriceDetail?.sellerBidPriceDetail?.tax?.bidTaxesPrice.state.total).toFixed(2)}</div>}</div>
                     <div className="ordr-dets-container-div7 tax-title-container">
                        <span>CA other fees</span>
                        <span>{parseFloat(surchargeTax).toFixed(3)}/gallon:</span>
                     </div>
                     <div className="ordr-dets-container-div8 tax-price">${formatNumberWithCommas(parseFloat(orderDetails?.sellerBidPriceDetail?.sellerBidPriceDetail?.tax?.bidTaxesPrice.surcharges.total).toFixed(2))}</div>
                  </div>
                  <div className="ordr-invoice-right-space" />
               </div>
               <div className="div9">
                  <OrderTotalPrice sumTitle="TOTAL" price={formatNumberWithCommas(parseFloat(orderDetails?.sellerBidPriceDetail?.sellerBidPriceDetail?.totalPrice).toFixed(2))} />
                  <div className="ordr-invoice-right-space" >
                     <div className="ordr-brand-address">
                        <span>Ordr, Inc.</span>
                        <span>4730 University Way NE</span>
                        <span>Suite 104-418</span>
                        <span>Seattle, WA 98105</span>
                     </div>

                  </div>

               </div>

            </div>
         </div >
      </div>
   );
}

export default OrdrReceipt

const OrderTotalPrice = ({ sumTitle, price }) => {

   return (
      <div className="ordr-total-container ordr-time-container-space">
         <b className="ordr-transection-container-div1">{sumTitle}:</b>
         <b className="ordr-transection-container-div2">$<span>{price}</span></b>
      </div>
   );
}

export function formatDateWithTimeZone(timestamp) {
   const seattleTimeZone = 'America/Los_Angeles';

   // Create a moment object with the provided timestamp and set the timezone to PDT (Pacific Daylight Time).
   const momentPDT = moment.tz(timestamp, seattleTimeZone).tz('America/Los_Angeles');

   // Format the date and time as per your requirements.
   const formattedDate = momentPDT.format('DD/MM/YYYY');
   const formattedTime = momentPDT.format('hh:mm A');

   return ({ date: formattedDate, time: formattedTime });
}

export function formatDate(date) {
   const formattedDate = new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
   }).format(new Date(date));

   return formattedDate;
}

export function formatTime(date) {
   const formattedTime = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "numeric",
      hour12: true,
   }).format(new Date(date));

   return formattedTime;
}